import { PLATFORMS } from '~/constants/platforms';
import { getDefaultAppDomain } from '~/utils/getDefaultAppDomain';

import { hasWhalarDomain } from './hasWhalarDomain';

export function getTargetUrl(
  accessToken: string,
  platform: PLATFORMS,
  redirectUrl: string | string[] | undefined,
  params: URLSearchParams
): URL {
  let url: URL;

  if (redirectUrl) {
    if (hasWhalarDomain(redirectUrl as string)) {
      url = new URL(redirectUrl as string);
    } else {
      url = new URL(
        `${getDefaultAppDomain(accessToken, platform)}${redirectUrl}`
      );
    }
  } else {
    url = new URL(getDefaultAppDomain(accessToken, platform));
  }

  params.forEach((val, key) => {
    url.searchParams.append(key, val);
  });

  return url;
}
